import { DEFAULT_PRECISION, FlexRow } from '@make-software/cspr-design';
import { BodyText, formatNumber } from '@block-explorer/ui';
import Big from 'big.js';
import { ftTokenAmountToCurrency } from '../../utils/ft-token-amount';
import React from 'react';
import FiatCurrency from '../multi-currency/multi-currency';
import styled from 'styled-components';

const StyledFlexRow = styled(FlexRow)<{ isColumn?: boolean }>(
  ({ theme, isColumn }) => ({
    flexDirection: isColumn ? 'column' : 'row',
    alignItems: isColumn ? 'flex-start' : 'center',
  })
);

interface TotalSupplyValueProps {
  totalSupply: string | number;
  price: number | null;
  symbol: string | null | undefined;
  isShortened?: boolean;
}

export const TotalSupplyValue = ({
  totalSupply,
  price,
  symbol,
  isShortened = false,
}: TotalSupplyValueProps) => {
  if (totalSupply == null) {
    return (
      <FlexRow align={'center'}>
        <BodyText size={4} scale={'md'}>
          N/A
        </BodyText>
      </FlexRow>
    );
  }

  if (Big(totalSupply).eq(0)) {
    return (
      <FlexRow align={'center'}>
        <BodyText size={4} scale={'md'}>
          &infin;
        </BodyText>
      </FlexRow>
    );
  }

  const totalSupplyNumber = formatNumber(totalSupply, {
    precision: DEFAULT_PRECISION,
  });

  const hasLargeTotalSupply = Big(totalSupply || '0').gt('1000000');
  const displayAsColumn = hasLargeTotalSupply && isShortened;

  return (
    <StyledFlexRow isColumn={displayAsColumn}>
      <FlexRow>
        {totalSupplyNumber} {symbol}
      </FlexRow>
      {price ? (
        <BodyText size={3} scale={'sm'} monotype variation="darkGray">
          (
          <FiatCurrency amount={ftTokenAmountToCurrency(totalSupply, price)} />)
        </BodyText>
      ) : null}
    </StyledFlexRow>
  );
};

export default TotalSupplyValue;
